"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const Loader_1 = require("./Loader");
const index_1 = require("./ReadyView/index");
exports.ConversionCanvas = () => {
    return (react_2.default.createElement(react_1.OsmosysCanvasPage, { defaultContextState: undefined, defaultPrefs: {
            view: 'stepsList',
        }, onQueryChange: ({ meta, prefs, state, canvasQueries }) => {
            const obj = canvasQueries &&
                canvasQueries.contentConversion &&
                canvasQueries.contentConversion.result &&
                canvasQueries.contentConversion.result.data &&
                canvasQueries.contentConversion.result.data.contentConversion;
            const newState = {
                draft: obj,
                run: state.run || false,
                sampleContentFeed: null,
                sampleContentItem: null,
                sampleContentItemKey: null,
                sampleInputHtml: state.sampleInputHtml || '',
                sampleOutputHtml: state.sampleOutputHtml || '',
                showContentImportPanel: false,
                source: obj,
            };
            return {
                meta,
                prefs,
                ready: !!(obj && meta),
                state: newState,
            };
        } },
        react_2.default.createElement(Loader_1.ContentConversionLoader, null),
        react_2.default.createElement(react_1.OsmosysCanvasPageReadyState, null,
            react_2.default.createElement(index_1.ConversionCanvasReadyView, null)),
        react_2.default.createElement(react_1.OsmosysCanvasPageLoadingState, null),
        react_2.default.createElement(react_1.OsmosysCanvasPageUndesiredState, null)));
};
exports.default = exports.ConversionCanvas;
//# sourceMappingURL=index.js.map